<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('withdraw.with_center')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
      <!-- <template #right>
        <span class="nav-right" @click="$router.push({path:'/WithdrawRecord'})">{{$t("withdraw.with_record")}}</span>
      </template> -->
    </van-nav-bar>
    <van-cell-group>
      <van-field v-model="withdraw_money" @blur="calculateAmount" :placeholder="$t('q14') + formatMoney(userInfo.money)" />
      <van-field v-model="paypassword"  :placeholder="$t('q15')" />
    </van-cell-group>
    <div class="p_c fee_row">
      <div class="fee_item">{{$t("withdraw.commission")}}：{{fee}}</div>
      <div class="fee_item">{{$t("withdraw.actual_arrival")}}：{{actualAmount}}</div>
    </div>
    <div class="type-switch">
      <div
        class="type-item"
        :class="{ active: bindType === 'bank', disabled: !hasBankMethod }"
        @click="changeWithdrawType('bank')"
      >
        {{ $t('setting.bank_card') }}
      </div>
      <div
        class="type-item"
        :class="{ active: bindType === 'crypto', disabled: !hasCryptoMethod }"
        @click="changeWithdrawType('crypto')"
      >
        {{ $t('setting.crypto_wallet') }}
      </div>
    </div>
    <div class="p_c" v-if="bindType === 'bank'">{{$t('q16')}}：{{ this.userInfo.name }}</div>
    <div class="hang_p_c">
      <input type="radio" checked>
      {{$t('withdraw.receive_method')}} ：
      <template v-if="bindType === 'crypto'">
        <div class="crypto-box">
          <div class="crypto-type">{{ $t('setting.crypto_wallet') }}</div>
          <div class="chain-switch">
            <div class="chain-item" :class="{ active: selectedChainType === 'TRC20' }" @click="changeChainType('TRC20')">TRC20</div>
            <div class="chain-item" :class="{ active: selectedChainType === 'ERC20' }" @click="changeChainType('ERC20')">ERC20</div>
          </div>
          <div class="wallet-address">{{ currentWalletAddress || $t('setting.wallet_address_tip') }}</div>
        </div>
      </template>
      <template v-else>
        <span v-if="hasBankMethod">{{ $t('setting.bank_card') }} {{ bankInfo.bankinfo }} {{ bankInfo.bankid }}</span>
        <span v-else>{{ $t('setting.set_bank') }}</span>
      </template>
    </div>
    
    <div class="sub-btn" @click="doWithdraw()">
      {{$t('q18')}}
    </div>
    <div class="shuoming">
      <div class="l_p q1">{{$t('q19')}}：</div>
      <div class="l_p">1、{{$t('q20')}}{{ withdrawRole.max }}</div>
      <div class="l_p">2、{{$t('q21')}}{{ withdrawRole.min }}</div>
      <div class="l_p">3、{{$t('q22')}}</div>
      <div class="l_p">4、{{$t('q23')}}</div>
    </div>
    <!-- <div class="main">
      <div class="withdrawMoney">
        <span>{{$t("withdraw.with_money")}} ({{$t("reservation.unit")}})</span>
        <div class="money">
          <div class="moneyNumber">
           
            <van-field v-model="withdraw_money" type="number" />
          </div>
          <span class="all" @click="allMoeny()">{{$t("index.all")}}</span>
        </div>
        <div class="information">
          <div class="description">
            <van-popover v-model="showPopover" trigger="click">
              <div class="popover-body" style="padding: 10px;">
                <p>1.{{$t("withdraw.single_limit")}}{{$t("withdraw.low")}}{{this.withdrawRole.min}}{{$t("withdraw.heigh")}}{{this.withdrawRole.max}}{{$t("reservation.unit")}}</p>
                <p>2.{{$t("withdraw.with_num")}}{{this.withdrawRole.num}}{{$t("withdraw.number")}}</p>
                <p>3.{{$t("withdraw.with_tip")}}</p></div>
              <template #reference @click="withdrawInfo()">
                <van-icon name="info-o" />
                {{$t("withdraw.limit_desc")}}
              </template>
            </van-popover>
          </div>

          <div class="balance">
            <span>{{$t("my.balance")}}：</span>
            <span class="number">{{ formatMoney(userInfo.money) }}{{$t("reservation.ge")}}</span>
          </div>
        </div>
      </div>
      <van-button class="withdraw_btn" type="default" @click="doWithdraw()"> {{$t("withdraw.immediately_withdraw")}}</van-button>

    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      money:"",
      paypassword:"",
      showPopover: false,
      withdraw_money:"",
      userInfo:{},
      withdrawRole:{},
      bankInfo:{},
      bindType: 'bank',
      selectedChainType: 'TRC20',
      fee: 0, // 手续费
      actualAmount: 0, // 实际到账金额
    };
  },
  methods: {
    formatMoney(money) {
      if (!money) return '0';
      return Math.floor(parseFloat(money)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if (res.data.is_bank) {
            this.bankInfo = res.data.info || {};
            this.selectedChainType = this.bankInfo.chain_type || (this.bankInfo.trc20_address ? 'TRC20' : 'ERC20');
            if (this.hasBankMethod) {
              this.bindType = 'bank';
            } else if (this.hasCryptoMethod) {
              this.bindType = 'crypto';
            }
          } else {
            // 进入/刷新页面后，未绑定收款账号时主动闪一次提示
            this.$toast.fail({
              message: this.$t("setting.set_bank"),
              duration: 2500,
            });
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    back(){
      return window.history.back();
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_withdraw_role'
      }).then(res=>{
        if(res.code === 200){
          this.withdrawRole = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    allMoeny(){
      this.withdraw_money = this.userInfo.money;
    },
    changeWithdrawType(type) {
      if (type === 'bank' && !this.hasBankMethod) {
        return false;
      }
      if (type === 'crypto' && !this.hasCryptoMethod) {
        this.$toast(this.$t("setting.wallet_address_tip"));
        return false;
      }
      this.bindType = type;
      if (type === 'crypto') {
        if (this.selectedChainType === 'ERC20' && !this.bankInfo.erc20_address && this.bankInfo.trc20_address) {
          this.selectedChainType = 'TRC20';
        }
        if (this.selectedChainType === 'TRC20' && !this.bankInfo.trc20_address && this.bankInfo.erc20_address) {
          this.selectedChainType = 'ERC20';
        }
      }
    },
    changeChainType(type) {
      if (type === 'TRC20' && !this.bankInfo.trc20_address) {
        this.$toast(this.$t("setting.wallet_address_tip"));
        return false;
      }
      if (type === 'ERC20' && !this.bankInfo.erc20_address) {
        this.$toast(this.$t("setting.wallet_address_tip"));
        return false;
      }
      this.selectedChainType = type;
    },
    doWithdraw(){
      if (this.needBindAccount) {
        this.$toast.fail({
          message: this.$t("setting.set_bank"),
          duration: 2500,
        });
        return false;
      }
      if(this.paypassword <= 0){
        
        this.$toast(this.$t('q24'));
        return false;
      }else
      if(this.withdraw_money <= 0){
        this.$toast(this.$t("setting.correct_money"));
        return false;
      }else {
        this.$http({
          method: 'post',
          data:{
            money:this.withdraw_money,
            paypassword:this.paypassword,
            withdraw_type:this.bindType,
            chain_type:this.bindType === 'crypto' ? this.selectedChainType : ''
          },
          url: 'user_set_withdraw'
        }).then(res=>{
          if(res.code === 200){
            location.reload()
            this.$toast(res.msg);
            this.getUserInfo();
            this.getUserWithdrawRole();
          }else if(res.code ===401){
            this.$toast(res.msg);
          }
        })
      }
    },
    withdrawInfo(){
      this.showPopover = true;
    },
    calculateAmount() {
      if (this.withdraw_money && !isNaN(this.withdraw_money)) {
        this.fee = 0; // 手续费固定为0
        this.actualAmount = Number(this.withdraw_money); // 实际到账等于输入金额
      } else {
        this.fee = 0;
        this.actualAmount = 0;
      }
    }
  },
  computed: {
    hasBankMethod() {
      return !!(this.bankInfo.bankid && this.bankInfo.bankinfo);
    },
    hasCryptoMethod() {
      return !!(this.bankInfo.trc20_address || this.bankInfo.erc20_address);
    },
    /** 是否需要先绑定收款账号 */
    needBindAccount() {
      if (!this.bankInfo) {
        return true;
      }
      if (this.bindType === 'bank') {
        return !this.hasBankMethod;
      }
      if (this.bindType === 'crypto') {
        return !this.currentWalletAddress;
      }
      return false;
    },
    currentWalletAddress() {
      if (this.bindType !== 'crypto') {
        return '';
      }
      return this.selectedChainType === 'ERC20'
        ? (this.bankInfo.erc20_address || '')
        : (this.bankInfo.trc20_address || '');
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      
      this.getUserInfo();
      this.getUserWithdrawRole();
     
    }
  },
  mounted(){
    this.getUserBankInfo();
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.p_c{
  color: #fff;
  padding:0 30px 20px;
  font-size: 28px;
  &.fee_row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .fee_item {
      color: #ededed;
      &:first-child {
        margin-right: 40px;
      }
    }
  }
}
.type-switch{
  display: flex;
  margin: 0 30px 20px;
  border: 1px solid #766350;
  border-radius: 12px;
  overflow: hidden;
  .type-item{
    flex: 1;
    text-align: center;
    color: #f3c7a2;
    font-size: 28px;
    padding: 20px 0;
    background: #2a2a2a;
    &.active{
      background: linear-gradient(#fde3ca, #e7b486);
      color: #68302c;
      font-weight: bold;
    }
    &.disabled{
      opacity: 0.5;
    }
  }
}
.hang_p_c{
  padding:0 0px 20px;
  border-bottom: 1px solid #c5a081;
  margin: 0 20px;
  color: #c5a081;
  font-size: 28px;
}
.crypto-box{
  display: inline-block;
  width: 100%;
  margin-top: 10px;
  .crypto-type{
    margin-bottom: 10px;
  }
  .wallet-address{
    margin-top: 12px;
    line-height: 1.5;
    word-break: break-all;
  }
}
.chain-switch{
  display: flex;
  margin-top: 10px;
  .chain-item{
    flex: 1;
    text-align: center;
    color: #f3c7a2;
    font-size: 24px;
    padding: 14px 0;
    border: 1px solid #766350;
    background: linear-gradient(120deg, #212121, #313131);
    &:first-child{
      margin-right: 16px;
    }
    &.active{
      background: linear-gradient(#fde3ca, #e7b486);
      color: #68302c;
      font-weight: bold;
    }
  }
}
.sub-btn{
  background: linear-gradient(#fde3ca, #e7b486);


  display: inline-block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 2rem;
  margin: 40px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
}
.shuoming{
  background: #2e2e2e;
  color: #c1c1c1;
  padding: 40px 36px;
  .l_p{
    font-size: 26px;
    margin-top: 16px;
    &.q1{
      font-size: 30px;
    }
  }
}
/deep/ .van-field__label{
  color: #ccc;
}
.van-cell-group{
  background-color: transparent;
  padding: 30px 0;
  &:after{
    display: none;
  }
}
.van-cell{
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  &+.van-cell{
    margin-top: 30px;
  }
  
  /deep/ .van-field__control{
    color: #f3c7a2;
  }
  &:after{
    display: none;
  }
}

.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}
.container .main{
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}
.container .main .withdrawMoney{
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}
.container .main .withdrawMoney .money .moneyNumber{
  font-size: 50px;
  display: flex;
  flex-direction: row;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money .all{
  color: #d10404;
}
.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0!important;
}
.container .main .withdrawMoney .information{
  padding-bottom: 30px;
}
.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
.container .main .withdrawMoney span{
  padding: 10px 0;
}
.container .main .withdrawMoney .information .balance .number{
  color: #d10404;
}
.withdraw_btn {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
</style>
